/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  import ApplicationState   from 'store/application';
  import ApplicationService from 'services/application';
  import { XHR }          from 'utils/XHR';

  const __vue_script__ = {

    name: "modal-metadata",

    data() {
      const project = ApplicationState.project.getState();
      const version = window.initConfig.version.split('-')[0].split('.');
      return {
        customcredits: false,
        powered_by:    window.initConfig.powered_by,
        urls:          window.initConfig.urls,
        docs_url:      `https://g3w-suite.readthedocs.io/en/v${version[0].replace('v','')}.${version[1]}.x/`,
        groups: Object.entries({
          general: [ 'title', 'name', 'description', 'abstract', 'keywords', 'fees', 'accessconstraints', 'contactinformation', 'wms_url' ],
          spatial: [ 'crs', 'extent' ],
          layers:  [ 'layers' ],
        }).reduce((g, [name, fields]) => {
          g[name] = fields.reduce((f, field) => {
            let value = project.metadata && project.metadata[field] ? project.metadata[field] : project[field];
            if (value) {
              //In case of layers that has geometry and no epsg, filter according to filter of project layers
              if ('layers' === field) { value = value.filter(l => 'NoGeometry' !== l.geometry && l.crs && l.crs.epsg) } 
              f[field] = { value, label: `sdk.metadata.groups.${name}.fields.${field}` };
            }
            return f;
          }, {});
          return g;
        }, {}),
        g3wsdk_info: '',
      };
    },

    methods: {

      showHideInfo(e) {
        const box       = e.target.closest(".layer_header");
        box.querySelector(".open-close").classList.toggle('fa-plus');
        box.querySelector(".open-close").classList.toggle('fa-minus');
      },

      sanitizeValue(value) {
        if (Array.isArray(value) || ('object' === typeof value && null !== value)) {
          value = Object.values(value).length ? value : '';
        }
        return value;
      },

      copy_g3wsdk_info(e) {
        const range = document.createRange();
        range.selectNode(e.target);
        window.getSelection().removeAllRanges();
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        alert('Copied to clipboard!');
      },

    },

    async created() {
      if (!!window.initConfig.credits) {
        try {
          const credits = await XHR.get({ url: window.initConfig.credits });
          this.customcredits = 'None' !== credits && credits;
        } catch (e) {
          console.warn(e);
        }
      }
    },

    mounted() {
      $('#modal-metadata').on('show.bs.modal', async () => {
      await Promise
        .allSettled([
          new Promise((resolve) => $script('https://unpkg.com/platform@1.3.6/platform.js', resolve)),
          new Promise((resolve) => ApplicationService.complete ? resolve() : ApplicationService.on('complete', resolve))
        ]);

        /** @since 3.8.0 */
        const platform = window.platform || {};

        this.g3wsdk_info = `
[g3wsdk.info]\n
- g3w-admin: __${initConfig.version}__
- g3w-client: __${process.env.g3w_client_rev}__
${Object.entries(ApplicationState.pluginsConfigs).map((p) => (`    - ${p[0]}: __${p[1].version}__`)).join('\n')}
- browser: __${platform.name} ${platform.version}__
- operating system: __${platform.os.toString()}__
`.trim();
      });

    },

  }

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal fade",attrs:{"id":"modal-metadata","tabindex":"-1"}},[_c('div',{staticClass:"modal-dialog",staticStyle:{"min-width":"80vw"}},[_c('div',{staticClass:"modal-content"},[_c('ul',{staticClass:"modal-header nav nav-tabs",attrs:{"role":"tablist"}},_vm._l((['general', 'spatial', 'layers', 'credits']),function(tab){return _c('li',{class:{ active: 'general' === tab }},[_c('a',{class:'metadata-item-tab '+ tab,attrs:{"data-toggle":"tab","href":'#metadata_' + tab}},[_c('i',{staticClass:"action-button",class:_vm.$fa(({ general: 'info', spatial: 'globe', layers: 'bars', credits: 'copyright' })[tab]),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('b',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.'+ tab +'.title'),expression:"'sdk.metadata.groups.'+ tab +'.title'"}]})])])}),0),_vm._v(" "),_c('div',{staticClass:"modal-body",staticStyle:{"min-height":"65vh","max-height":"70vh"},attrs:{"id":"project-catalog"}},[_c('div',{staticClass:"tab-content"},[_vm._l((['general', 'spatial']),function(item){return _c('div',{staticClass:"tab-pane fade",class:{ in: 'general' === item, active: 'general' === item },attrs:{"id":'metadata_' + item}},_vm._l((_vm.groups[item]),function(data,field){return _c('div',{staticClass:"row row-info"},[_c('div',{staticClass:"wrap-content-tab"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:(data.label),expression:"data.label"}],staticClass:"col-sm-2 metadata-label"}),_vm._v(" "),('keywords' === field || 'wms_url'=== field)?_c('div',{staticClass:"col-sm-10 value"},[_c('span',[_vm._v(_vm._s([].concat(data.value).join(', ')))])]):('abstract' === field || (!Array.isArray(data.value) && typeof data.value !== 'object'))?_c('div',{staticClass:"col-sm-10 value"},[_c('span',{domProps:{"innerHTML":_vm._s(data.value)}})]):('contactinformation' !== field)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((data.value),function(value,index){return _c('div',[('extent' === field)?_c('span',{staticClass:"bbox-labels"},[_vm._v(_vm._s((['MINX', 'MINY', 'MAXX', 'MAXY'])[index]))]):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(value))])])}),0):_c('div',{staticClass:"col-sm-10 value"},_vm._l((data.value),function(value,info){return _c('div',[_c('div',{staticClass:"row metadata-contact-row"},[_c('div',{staticClass:"col-sm-2 metadata-contact-label"},[_c('i',{staticClass:"contact-icon",class:_vm.$fa(({ contactelectronicmailaddress: 'mail', personprimary: 'user', contactvoicetelephone: 'mobile' })[info]),attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:(("sdk.metadata.groups.general.fields.subfields.contactinformation." + info)),expression:"`sdk.metadata.groups.general.fields.subfields.contactinformation.${info}`"}]})]),_vm._v(" "),('personprimary' === info)?_c('div',{staticClass:"col-sm-10"},_vm._l((value),function(subvalue,key){return _c('div',[_c('span',{directives:[{name:"t",rawName:"v-t",value:(("sdk.metadata.groups.general.fields.subfields.contactinformation." + key)),expression:"`sdk.metadata.groups.general.fields.subfields.contactinformation.${key}`"}],staticClass:"metadata-contact-label"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(subvalue))])])}),0):('contactelectronicmailaddress' === info )?_c('div',{staticClass:"col-sm-10"},[_c('a',{attrs:{"href":("mailto: " + (_vm.sanitizeValue(value)))}},[_c('b',[_vm._v(_vm._s(_vm.sanitizeValue(value)))])])]):_c('div',{staticClass:"col-sm-10"},[_vm._v(_vm._s(_vm.sanitizeValue(value)))])])])}),0)])])}),0)}),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"metadata_layers"}},_vm._l((_vm.groups.layers.layers.value),function(layer){return _c('div',{staticClass:"row-info"},[_c('h4',{staticClass:"layer_header",attrs:{"data-toggle":"collapse","data-target":("#" + (layer.id))},on:{"click":_vm.showHideInfo}},[_c('i',{class:'layer-header-icon action-button ' + _vm.g3wtemplate.font['NoGeometry' === layer.geometrytype ? 'table' : 'map'],attrs:{"aria-hidden":"true"}}),_vm._v(" "),_c('span',{staticClass:"layer-name"},[_vm._v(_vm._s(layer.name))]),_vm._v(" "),_c('span',{staticClass:"action-button open-close",class:_vm.$fa('plus')})]),_vm._v(" "),_c('div',{staticClass:"collapse",attrs:{"id":layer.id}},[_c('ul',{staticClass:"metadata-nav-tabs nav nav-tabs layer-nav-tabs",attrs:{"role":"tablist"}},[_c('li',{staticClass:"active spatial-tab",attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.groups.general'),expression:"'sdk.metadata.groups.layers.groups.general'"}],attrs:{"href":("#layer_general_" + (layer.id)),"aria-controls":"general","role":"tab","data-toggle":"tab"}})]),_vm._v(" "),('NoGeometry' !== layer.geometrytype)?_c('li',{staticClass:"spatial-tab",attrs:{"role":"presentation"}},[_c('a',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.groups.spatial'),expression:"'sdk.metadata.groups.layers.groups.spatial'"}],attrs:{"href":("#layer_spatial_" + (layer.id)),"aria-controls":"profile","role":"tab","data-toggle":"tab"}})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"tab-content layer-tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"role":"tabpanel","id":("layer_general_" + (layer.id))}},[_c('div',{staticClass:"container-fluid"},[_vm._l((['metadata.title', 'name', 'source', 'metadata.abstract', 'metadata.keywords', 'metadata.metadataurl.onlineresource', 'metadata.dataurl.onlineresources', 'metadata.attributes']),function(attr){return [(undefined !== attr.split('.').reduce(function (a, b) { return a[b]; }, layer))?_c('div',{staticClass:"row layer-row"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]),expression:"'sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]"}],staticClass:"col-md-2 col-sm-12 metadata-label"}),_vm._v(" "),('metadata.title' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.metadata.title))]):_vm._e(),_vm._v(" "),('name' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.name))]):_vm._e(),_vm._v(" "),('source' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.source.type))]):_vm._e(),_vm._v(" "),('metadata.abstract' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value",domProps:{"innerHTML":_vm._s(layer.metadata.abstract)}}):('metadata.keywords' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_vm._v(_vm._s(layer.metadata.keywords.join(', ')))]):('metadata.metadataurl.onlineresource' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_c('a',{attrs:{"href":layer.metadata.metadataurl.onlineresources}},[_vm._v(_vm._s(layer.metadata.metadataurl.onlineresources))])]):('metadata.dataurl.onlineresources' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value"},[_c('a',{attrs:{"href":layer.metadata.dataurl.onlineresources}},[_vm._v(_vm._s(layer.metadata.dataurl.onlineresources))])]):('metadata.attributes' === attr)?_c('div',{staticClass:"col-md-10 col-sm-12 value",staticStyle:{"overflow":"auto"}},[_c('table',{staticClass:"table table-striped",staticStyle:{"background-color":"#eee !important"}},[_c('thead',[_c('tr',_vm._l((layer.metadata.attributes[0]),function(value,header){return _c('th',[_vm._v(_vm._s(header))])}),0)]),_vm._v(" "),_c('tbody',_vm._l((layer.metadata.attributes),function(a){return _c('tr',_vm._l((a),function(value,header){return _c('td',[_vm._v(_vm._s(value))])}),0)}),0)])]):_vm._e()]):_vm._e()]})],2)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"role":"tabpanel","id":("layer_spatial_" + (layer.id))}},[_c('div',{staticClass:"container-fluid"},[_vm._l((['crs', 'geometrytype', 'bbox', 'metadata.crs']),function(attr){return [(undefined !== attr.split('.').reduce(function (a, b) { return a[b]; }, layer))?_c('div',{staticClass:"row layer-row"},[('metadata.crs' === attr)?_c('div',{staticClass:"col-md-2 col-sm-12 metadata-label"},[_vm._v("CRS")]):_c('div',{directives:[{name:"t",rawName:"v-t",value:('sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]),expression:"'sdk.metadata.groups.layers.fields.subfields.' + attr.replace('metadata.', '').split('.')[0]"}],staticClass:"col-md-2 col-sm-12 metadata-label"}),_vm._v(" "),('crs' === attr)?_c('div',{staticClass:"col-sm-10 value"},[_vm._v(_vm._s(layer.crs.epsg))]):('geometrytype' === attr)?_c('div',{staticClass:"col-sm-10 value"},[_vm._v(_vm._s(layer.geometrytype))]):('bbox' === attr)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((layer.bbox),function(value,key){return _c('p',[_c('span',{staticStyle:{"font-weight":"bold","margin-right":"5px"}},[_vm._v(_vm._s(key))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(value))])])}),0):('metadata.crs' === attr)?_c('div',{staticClass:"col-sm-10 value"},_vm._l((layer.metadata.crs),function(crs){return _c('div',[_c('span',[_vm._v(_vm._s(crs))])])}),0):_vm._e()]):_vm._e()]})],2)])])])])}),0),_vm._v(" "),_c('div',{staticClass:"tab-pane fade",attrs:{"id":"metadata_credits"}},[(!!_vm.customcredits)?_c('div',{staticClass:"customcredits",domProps:{"innerHTML":_vm._s(_vm.customcredits)}}):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticClass:"g3w-credits-block"},[_c('div',{directives:[{name:"t",rawName:"v-t",value:('credits.g3wSuiteFramework'),expression:"'credits.g3wSuiteFramework'"}],staticClass:"credit-title-logo",staticStyle:{"padding":"5px"}}),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":"https://g3wsuite.it/"}},[_c('img',{staticClass:"g3w-suite-logo",attrs:{"src":((_vm.urls.clienturl) + "images/g3wsuite_logo.png"),"alt":""}})]),_vm._v(" "),_c('div',{directives:[{name:"t",rawName:"v-t",value:('credits.g3wSuiteDescription'),expression:"'credits.g3wSuiteDescription'"}],staticStyle:{"margin-top":"10px"}})]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{directives:[{name:"t",rawName:"v-t:pre",value:('credits.productOf'),expression:"'credits.productOf'",arg:"pre"}],staticClass:"credit-title-logo g3w-credits-block",staticStyle:{"font-size":"1em","display":"flex","justify-content":"center"}},[_c('a',{staticStyle:{"text-align":"center!important"},attrs:{"href":"http://www.gis3w.it","target":"_blank"}},[_c('img',{staticClass:"img-responsive",staticStyle:{"margin-left":"auto","display":"block","margin-right":"auto"},attrs:{"width":"60","src":((_vm.urls.clienturl) + "images/logo_gis3w_156_85.png"),"alt":""}})])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('address',{staticStyle:{"line-height":"1.3","text-align":"center","margin-top":"5px","display":"flex","justify-content":"center","gap":"5px"},attrs:{"id":"address-credits"}},[_c('span',[_vm._v("📍 Montecatini Terme - Italy")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"tel:+393938534336"}},[_vm._v("📱 +39 393 8534336")]),_vm._v(" "),_c('a',{staticStyle:{"color":"#000"},attrs:{"href":"mailto:info@gis3w.it"}},[_vm._v("✉️ info@gis3w.it")])]):_vm._e(),_vm._v(" "),(_vm.powered_by)?_c('div',{staticStyle:{"display":"flex","justify-content":"center","gap":"20px"}},[_c('a',{attrs:{"href":_vm.docs_url,"rel":"nofollow","target":"_blank"}},[_vm._v("📖 Docs")]),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@gis3w.it?subject=Sponsoring%20G3W-SUITE%20development&body=Hi%20there,%20I'd%20like%20to%20fund%20some%20code%20changes:"}},[_vm._v("❤️ Sponsor")]),_vm._v(" "),_c('a',{attrs:{"href":"https://github.com/g3w-suite","target":"_blank"}},[_vm._v("🐞 Report a bug")])]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.powered_by && _vm.g3wsdk_info)?_c('pre',{staticStyle:{"cursor":"pointer"},attrs:{"title":"click to copy"},on:{"click":_vm.copy_g3wsdk_info}},[_vm._v(_vm._s(_vm.g3wsdk_info))]):_vm._e()])],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer",staticStyle:{"position":"relative","background":"#fff"}},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('close'),expression:"'close'"}],staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}})])])])])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e8986dac_0", { source: ".metadata-item-tab.general[data-v-e8986dac]{color:var(--skin-primary)}.metadata-item-tab.layers[data-v-e8986dac]{color:var(--skin-warning)}.metadata-item-tab.spatial[data-v-e8986dac]{color:var(--skin-success)}#project-catalog[data-v-e8986dac]{background:0 0}.modal-header.nav[data-v-e8986dac]{display:flex;gap:1px;justify-content:space-between}.modal-header.nav li[data-v-e8986dac]{background-color:#e4e4e4;width:100%}.modal-header.nav li.active[data-v-e8986dac]{background-color:#fff}.modal-header.nav li.active a.metadata-item-tab[data-v-e8986dac]{border-bottom-color:var(--bgcolor)!important;border-bottom-width:4px;background-color:transparent!important;color:#2c3b41!important}.modal-header.nav li a.metadata-item-tab[data-v-e8986dac]{height:100%;margin:0;font-size:1.1em;border-top:0;border-right:0;border-left:0;border-bottom:4px solid #e2e2e2}.modal-header.nav li a[data-v-e8986dac]{text-align:center}.modal-header.nav li a i[data-v-e8986dac]{margin-right:5px}.metadata-item-tab[data-v-e8986dac]{margin-right:10px;border-radius:3px;margin-bottom:10px}.tab-title[data-v-e8986dac]{position:absolute;bottom:10px;right:auto}.row-info[data-v-e8986dac]{margin:0!important;padding-top:10px;padding-bottom:10px;border-bottom:1px solid #eee}.row-info .label[data-v-e8986dac]{font-weight:700}.h_100[data-v-e8986dac]{height:100%}#project-catalog[data-v-e8986dac]{position:relative;overflow:auto}.nav-tabs[data-v-e8986dac]{border-bottom:0 none}.metadata-label[data-v-e8986dac]{font-weight:700;font-size:1.1em}.bbox-labels[data-v-e8986dac]{font-weight:700}.metadata-contact-label[data-v-e8986dac]{font-weight:700}.contact-icon[data-v-e8986dac]{margin-right:3px}.metadata-contact-row[data-v-e8986dac]{margin-bottom:5px}.layer_header[data-v-e8986dac]{padding:5px;margin-bottom:0;margin-top:0;cursor:pointer}.layer-name[data-v-e8986dac]{font-weight:700}.layer-header-icon[data-v-e8986dac]{margin-right:10px;color:#999}.layer_header span.open-close[data-v-e8986dac]{position:absolute;right:5px;color:#999}.layer-row[data-v-e8986dac]{padding:10px;border-bottom:1px solid #e2e2e2}.layer-nav-tabs[data-v-e8986dac]{border-bottom:0 solid #ddd}.layer-nav-tabs>li.active>a[data-v-e8986dac],.layer-nav-tabs>li.active>a[data-v-e8986dac]:focus,.layer-nav-tabs>li.active>a[data-v-e8986dac]:hover{border-width:0}.layer-nav-tabs>li>a[data-v-e8986dac]{border:none;color:#aeaeae}.layer-nav-tabs>li.active>a[data-v-e8986dac],.layer-nav-tabs>li>a[data-v-e8986dac]:hover{border:none;background:0 0}.layer-nav-tabs>li>a[data-v-e8986dac]::after{content:\"\";height:2px;position:absolute;width:100%;left:0;bottom:-1px;transition:all 250ms ease 0s;transform:scale(0)}.layer-nav-tabs>li.active>a[data-v-e8986dac]::after,.layer-nav-tabs>li:hover>a[data-v-e8986dac]::after{transform:scale(1)}.layer-tab-content[data-v-e8986dac]{margin:10px;background-color:#eee;overflow:auto}.spatial-tab[data-v-e8986dac]{font-weight:700}.metadata-nav-tabs>li.active>a[data-v-e8986dac],.metadata-nav-tabs>li>a[data-v-e8986dac]:hover{color:var(--skin-color)!important}.metadata-nav-tabs>li>a[data-v-e8986dac]::after{background:var(--skin-color)}.modal-header.nav .action-button[data-v-e8986dac]:hover{background-color:transparent}.credit-title-logo[data-v-e8986dac]{font-weight:700;font-size:1.2em;margin-bottom:15px}.g3w-credits-block[data-v-e8986dac]{text-align:center!important;margin-bottom:20px}.g3w-suite-logo[data-v-e8986dac]{width:50%!important}.customcredits[data-v-e8986dac]{margin-bottom:10px;margin-top:5px;text-align:center}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-e8986dac"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ModalMetadata.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__